import { getOrigin, getOutlookSpacesPath, getCalendarPath } from 'owa-url';
import { isFeatureEnabled } from 'owa-feature-flags';
import type { ProjectId } from 'owa-timestream-types';
import { getProject } from 'owa-timestream-store';
import { useProjectId } from './useProjectId';
import getProjectName from '../util/getProjectName';

export default function useProjectHref(): [string, string, ProjectId] {
    const projectId = useProjectId();
    const project = getProject(projectId);
    const projectUrl =
        project.appName === 'OutlookCalendar' ||
        (isFeatureEnabled('cal-board-migrationMessaging') &&
            isFeatureEnabled('cal-board-multipleBoards-dev'))
            ? getOrigin() + getCalendarPath() + 'view/board/id/' + projectId
            : getOrigin() + getOutlookSpacesPath() + 'view/' + projectId;
    return [getProjectName(projectId), projectUrl, projectId];
}
